import { CampaignSipTrunkCreateRequestDto } from '@shared/services/apiService/apiService';
import { CampaignSipTrunkValue } from '../model/type';
import { SipTrunkType } from '@shared/constants/campaign.constants';

export const campaignSipTrunkCreateRequestMapper = (data: CampaignSipTrunkValue) => {
  const mappedForm: CampaignSipTrunkCreateRequestDto = {
    type: data.type,
    numbers: data.numbers,
  };

  if (data.type === SipTrunkType.OUTBOUND) {
    mappedForm.authUsername = data.authUsername;
    mappedForm.authPassword = data.authPassword;
    mappedForm.address = data.address;
    if (data.transport) {
      mappedForm.transport = data.transport;
    }
    mappedForm.fromHost = data.fromHost?.trim() || null;
    mappedForm.dialCountry = data.dialCountry || null;
    mappedForm.dialPrefix = data.dialPrefix?.trim() || null;
  } else {
    mappedForm.allowedAddresses = data.allowedAddresses;
  }

  return mappedForm;
};
